import { render, staticRenderFns } from "./insertAccessGroup.vue?vue&type=template&id=1b283fab&scoped=true"
import script from "./insertAccessGroup.vue?vue&type=script&lang=js"
export * from "./insertAccessGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b283fab",
  null
  
)

export default component.exports